import { apiRoutes } from "../../config"
import { api } from "../../utils/lib/api"
import axios from "axios"
import { keyAccessToken, keyUserId } from "../../assets/js/SessionStorageNames"

export const accVtex = async (method,ent, data) =>{
    try {
        if(method === "POST"){
            const url = `${apiRoutes.vtex.acc}/${ent}`
            return (await api.post(url, data)).data
        }
        if(method === "GET"){
            const url = `${apiRoutes.vtex.acc}/${ent}/acc/${data ? data : ''}`
            return (await api.get(url)).data
        }
    } catch (error) {
        console.error(error)
        return error
    }
}

export const syncProductsVtex = async (ent, accUser)=>{
    try {
        //Obtenemos el id de la cuenta de Vtex
        const accId = await accVtex('GET', ent, accUser).then((res)=> Object.values(res.data).map(item => item._id))        
        const url = `${apiRoutes.vtex.products}/${ent}/acc/${accId}/sync`
        return (await api.put(url)).data
    } catch (error) {
        console.log(error)
        throw new Error(error)

    }
}

export const downloadCategoriesVtex = async (ent, accUser)=>{
    try {
        //Obtenemos el id de la cuenta de Vtex
        const accId = await accVtex('GET', ent, accUser).then((res)=> Object.values(res.data).map(item => item._id))        
        const url = `${apiRoutes.vtex.categories}/${ent}/download/${accId}/categories`
        return (await api.get(url))
    } catch (error) {
        console.log(error)
        throw new Error(error)

    }
}

export const updateProductsVtex = async (ent, accUser, skuId)=>{
    try {
        //Obtenemos el id de la cuenta de Vtex
        const accId = await accVtex('GET', ent, accUser).then((res)=> Object.values(res.data).map(item => item._id))        
        const url = `${apiRoutes.vtex.products}/${ent}/acc/${accId}/updateProducts?productSkuId=${skuId}`
        return (await api.post(url))
    } catch (error) {
        console.log(error)
        throw new Error(error)

    }
}
// export const getWarehouses = async (ent) =>{
//     try {
//         const url = `${apiRoutes.vtex.getWarehouses}/${ent}/warehouses`
//         return (await api.get(url)).data
//     } catch (error) {
//         console.error(error)
//         return error
//     }
// }

/**
 * Get enterprise products by account for VTEX
 * @param {string} entId - Enterprise ID
 * @param {string} accId - Account ID
 * @param {Object} params - Query parameters
 * @param {Object} options - Additional options (e.g., cancelToken)
 * @returns {Promise} API response with products data
 */
export const getEnterpriseProductsVtex = async (entId, accId, params = {}, options = {}) => {
    try {
        const { pageItemCount, pageNumber, isLinked, search } = params;
        
        // Build query parameters
        const queryParams = new URLSearchParams();
        if (pageItemCount) queryParams.append('pageItemCount', pageItemCount);
        if (pageNumber) queryParams.append('pageNumber', pageNumber);
        if (isLinked !== undefined) queryParams.append('isLinked', isLinked);
        if (search) queryParams.append('search', search);
        
        const queryString = queryParams.toString();
        const url = `${apiRoutes.vtex.products}/${entId}/acc/${accId}/products${queryString ? `?${queryString}` : ''}`;
        
        return await api.get(url, options);
    } catch (error) {
        console.log(error);
        throw new Error(error);
    }
};

// Resuelve la cuenta VTEX (filtrada por usuario) a un unico accId. Lanza un error claro si no
// existe, en vez de construir URLs invalidas como /acc//... que el backend responde como 404.
const resolveVtexAccId = async (ent, accUser) => {
    const accIds = await accVtex('GET', ent, accUser).then((res) => Object.values(res.data).map(item => item._id));
    const accId = Array.isArray(accIds) ? accIds[0] : accIds;
    if (!accId) throw new Error('No se encontró una cuenta VTEX para esta empresa/usuario');
    return accId;
};

export const getMarketPlaces = async (ent, accUser)=>{
    try {
        //Obtenemos el id de la cuenta de Vtex
        const accId = await resolveVtexAccId(ent, accUser);
        const url = `${apiRoutes.vtex.campaigns}/${ent}/acc/${accId}/fetchVtexMarketplaces`
        return (await api.get(url))
    } catch (error) {
        console.log(error)
        throw new Error(error)

    }
}

export const sendCampaignVtex = async (ent, accUser, data, excelFile = null, pricelistName = '')=>{
    try {
        const accId = await resolveVtexAccId(ent, accUser);
        const url = excelFile
            ? `${apiRoutes.vtex.campaigns}/${ent}/acc/${accId}/createCampaignFromExcel`
            : `${apiRoutes.vtex.campaigns}/${ent}/acc/${accId}/createCampaign`
        console.log(`URL: ${url}`)
        console.log(`Data: ${JSON.stringify(data)}`)
        if (excelFile) {
            const formData = new FormData();
            formData.append('xlsx', excelFile);
            formData.append('pricelistName', pricelistName);
            Object.entries(data).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach((item) => formData.append(`${key}[]`, item));
                } else {
                    formData.append(key, value);
                }
            });

            return (await axios.post(url, formData, {
                headers: {
                    "x-api-key": process.env.REACT_APP_API_KEY,
                    "x-access-token": localStorage.getItem(keyAccessToken),
                    "x-user-id": localStorage.getItem(keyUserId),
                },
            }));
        }
        return (await api.post(url,data))
    } catch (error) {
        console.log(error)
        throw new Error(error)

    }
}

export const getCampaignVtex = async (ent)=>{
    try {
        const url = `${apiRoutes.vtex.campaigns}/${ent}/fetchVtexCampaigns`
        console.log(`URL: ${url}`)
        return (await api.get(url))
    } catch (error) {
        console.log(error)
        throw new Error(error)

    }
}

export const deleteCampaignVtex = async (ent, accUser, data)=>{
    try {
        const accId = await resolveVtexAccId(ent, accUser);
        const url = `${apiRoutes.vtex.campaigns}/${ent}/acc/${accId}/deleteCampaign`
        console.log(`URL: ${url}`)
        console.log(`Data: ${JSON.stringify(data)}`)
        return (await api.post(url,data))
    } catch (error) {
        console.log(error)
        throw new Error(error)

    }
}

export const getReportVtex = async (ent, fileType)=>{
    try {
        const url = `${apiRoutes.vtex.products}/${ent}/report/${fileType}`
        return (await api.get(url))
    } catch (error) {
        console.log(error)
        throw new Error(error)

    }
}